module.exports = "https://cdn2-fs.clearscore.com/flux/images/e597589b1852f5dab6548f953b0785d9.jpg";